import { useCallback, useEffect, useRef, useState } from "react";
import { useWebSocketContext } from "../contexts/WebSocketProvider";

export default function useAddSettlement() {
  const { send, isConnected, connect } = useWebSocketContext();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const mountedRef = useRef(true);
  const retryTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
      if (retryTimeoutRef.current) clearTimeout(retryTimeoutRef.current);
    };
  }, []);

  const addSettlement = useCallback(
    async (payload, attempt = 0) => {
      if (!mountedRef.current) return;

      setIsLoading(true);
      setError("");

      try {
        if (!isConnected) {
          await connect();
        }

        console.log("Adding settlement with payload:", payload);

        const response = await send("cms_add_settlement_record", payload);

        if (!response || response.type !== "cms_add_settlement_record_response") {
          throw new Error("Invalid response from server");
        }

        setMessage(response.message || "Settlement added successfully");
        return response;
      } catch (err) {
        console.error("Settlement error:", err);
        setError(err.message || "Failed to add settlement");
      } finally {
        if (mountedRef.current) setIsLoading(false);
      }
    },
    [send, isConnected, connect]
  );

  return {
    addSettlement,
    isLoading,
    error,
    message,
  };
}
